export default __webpack_public_path__ + "static/media/saltoLogo.01b3348f.svg";